import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  VStack,
  Text,
  Box,
  Button,
} from '@chakra-ui/react';
import { DeferredDocument } from 'types/documents';

interface IgnoreDocumentModalProps {
  isOpen: boolean;
  onClose: () => void;
  document: DeferredDocument | null;
  isProcessing: boolean;
  onConfirm: () => void;
}

const IgnoreDocumentModal = ({
  isOpen,
  onClose,
  document,
  isProcessing,
  onConfirm,
}: IgnoreDocumentModalProps) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Ignore Document (Cannot Obtain)</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <VStack spacing={4} align="stretch">
            <Text>
              Are you sure you want to ignore this document requirement?
            </Text>
            <Box
              bg="orange.50"
              p={4}
              borderRadius="md"
              borderWidth="1px"
              borderColor="orange.200"
            >
              <Text fontWeight="600" color="secondaryGray.900">
                {document?.text}
              </Text>
              <Text fontSize="sm" color="orange.700" mt={2} fontWeight="500">
                ⚠️ This will negatively impact the document score
              </Text>
            </Box>
          </VStack>
        </ModalBody>
        <ModalFooter>
          <Button variant="ghost" mr={3} onClick={onClose}>
            Cancel
          </Button>
          <Button
            colorScheme="red"
            onClick={onConfirm}
            isLoading={isProcessing}
          >
            Ignore Document
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default IgnoreDocumentModal;
